// ── Zone-based positioning types (SMA-41 Phase 1) ──
//
// Replaces tile-coordinate positioning with zone-aware positioning.
// Each scene in the journey-manifest is a zone; player positions are
// expressed as (zoneId, localX, localY) where localX/Y are normalized
// [0–1] coordinates within the zone's walkable area.
// ── Messages ──
export const MSG_ZONE_ENTER = 'zone_enter';
export const MSG_ZONE_LEAVE = 'zone_leave';
export const MSG_ZONE_TRANSITION_REQUEST = 'zone_transition_request';
/** Client→server: push the local player's normalized position within their current zone (SMA-42). */
export const MSG_LOCAL_POSITION_UPDATE = 'local_position_update';
/** Server→client: snapshot of zone-connection graph for client-side preloading (SMA-42). */
export const MSG_ZONE_GRAPH = 'zone_graph';
export const DEFAULT_ZONE_ID = 's-001-cottage-crest';
export function sceneKeyToRealm(sceneKey) {
    const prefix = sceneKey.split('-')[1];
    if (!prefix)
        return 'hill';
    const num = parseInt(prefix, 10);
    if (num < 100)
        return 'hill';
    if (num < 200)
        return 'verdana_fields';
    if (num < 300)
        return 'sablewind_reaches';
    if (num < 400)
        return 'frostmere_expanse';
    if (num < 500)
        return 'ember_mire';
    return 'hill';
}
//# sourceMappingURL=zone.js.map